import numeral from "numeral";
import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useBalanceStore } from "../../../_store/balanceStore";
import { useEducationStore } from "../../../_store/educationStore";
import { useFuturePlanStore } from "../../../_store/futurePlanStore";
import { useTaxStore } from "../../../_store/taxplanStore";
import { useUserStore } from "../../../_store/userStore";
import { MTButton } from "../../../components/button/MTButton";
import { HeaderTitle } from "../../../components/header/Header";
import { ImageMain } from "../../../components/img/Img.Main";
import Container from "../../../components/layout/Container";
import {
  ChildrenEducationExpensePDF,
  FutureCarExpensePDF,
  FutureChildrenExpensePDF,
  FutureCollectionExpensePDF,
  FutureETCExpensePDF,
  FutureHomeExpensePDF,
  FutureTravelExpensePDF,
  LegacyIncomePDF,
  OtherIncomePDF,
  PropertyIncomePDF,
  SellBusinessIncomePDF,
} from "../../../functions/pdfGenerateFunction/pdfFutureFunction";
import { useIsMobile } from "../../../utils/useIsMobile";
import { STYLE_REPORT_CONTAIN, STYLE_TEXT_CYAN } from "../../../utils/useStyle";
import {
  options_education_rank,
  options_under_education,
} from "../../education/functions/options";
import { ChartCashFlow } from "../../future_plan/components/VIChartCashFlow.Main";
import { first_reload } from "../../tax_plan/functions/firstLoad";
import { HeaderReport } from "../components/header.main";
import FuturePlanDetail from "./components/futureplanDetail";
import FuturePlanIncomeDetail from "./components/futurePlanIncomeDetail";
import { findDebtCreditcard, findDebtInformalShortterm, findDebtShortterm, findDebtShorttermOther, findLongDebtCar, findLongDebtOther, findLongDebtPlace } from "../../../functions/futurePlan/futurechartFunction";
import { calDebtCreditCard } from "../../../utils/useFunctions";

const FlowSection = ({ futurePlanData }) => {
  const balanceData = useBalanceStore((state) => state.balanceData);
  const educationData = useEducationStore((state) => state.educationData);

  const merge_keys = useMemo(() => {
      let income_keys = futurePlanData?.cash_flow_keys?.filter(
        (cash_flow_key) => {
          return cash_flow_key.includes("income");
        }
      );
      let expenese_keys = futurePlanData?.cash_flow_keys?.filter(
        (cash_flow_key) => {
          return cash_flow_key.includes("expenese");
        }
      );
      let merge_income_keys = [
        // ...income_keys,
        "income_peryear",
        "remain_accumulate",
        "pension_peryear",
        "income_investment",
      ];
      let merge_expenese_keys = [
        // ...expenese_keys,
        "outcome_peryear",
        "out_come_stable",
      ];
  
      let merge_keys = [...merge_expenese_keys, ...merge_income_keys];
      // merge_keys = [];
  
      // หนี้ดอกลอย
      let debtShortList = balanceData?.debt_short_list?.find(
        (item) => item?.options_debt_short === "debt_shortterm_other"
      )?.short_term_others;
  
      if (debtShortList?.length > 0) {
        merge_keys = [
          ...merge_keys,
          ...findDebtShorttermOther(balanceData, futurePlanData).title,
        ];
      }
  
      // หนี้ีนอกระบบ
      let debtInformalShortterm = balanceData?.debt_short_list?.find(
        (item) => item?.options_debt_short === "debt_informal_shortterm"
      )?.informal_short_terms;
  
      if (debtInformalShortterm?.length > 0) {
        merge_keys = [
          ...merge_keys,
          ...findDebtInformalShortterm(balanceData, futurePlanData).title,
        ];
      }
  
      // เงินกู้ระยะสั้น
      let debtShorShortList = balanceData?.debt_short_list?.find(
        (item) => item?.options_debt_short === "debt_shortterm"
      )?.short_terms;
  
      if (debtShorShortList?.length > 0) {
        merge_keys = [
          ...merge_keys,
          ...findDebtShortterm(balanceData, futurePlanData).title,
        ];
      }
  
      // บัตรเครดิต
      let debtCreditcard = balanceData?.debt_short_list?.find(
        (item) => item?.options_debt_short === "debt_creditcard"
      )?.credit_cards;
  
      if (debtCreditcard?.length > 0) {
        merge_keys = [
          ...merge_keys,
          ...findDebtCreditcard(balanceData, futurePlanData).title,
        ];
      }
  
      // หนี้ระยะยาว รถ
      let debtCar = balanceData?.debt_long_list?.find(
        (item) => item?.options_debt_long === "debt_car"
      )?.debt_long_cars;
  
      if (debtCar?.length > 0) {
        merge_keys = [
          ...merge_keys,
          ...findLongDebtCar(balanceData, futurePlanData).title,
        ];
      }
  
      // หนี้ระยะยาว บ้าน
      let DebtPlace = balanceData?.debt_long_list?.find(
        (item) => item?.options_debt_long === "debt_car"
      )?.debt_long_cars;
  
      if (DebtPlace?.length > 0) {
        merge_keys = [
          ...merge_keys,
          ...findLongDebtPlace(balanceData, futurePlanData).title,
        ];
      }
  
      // หนี้ระยะยาว อื่นๆ
      let DebtOther = balanceData?.debt_long_list?.find(
        (item) => item?.options_debt_long === "debt_long_other"
      )?.debt_long_others;
  
      if (DebtOther?.length > 0) {
        merge_keys = [
          ...merge_keys,
          ...findLongDebtOther(balanceData, futurePlanData).title,
        ];
      }
  
      return merge_keys;
    }, [futurePlanData]);

  const dataDebt = useMemo(() => {
      let dataDebt = [];
  
      for (const merge_key of merge_keys) {
        let dataDebtItems = [];
        for (const cash_flow_item of futurePlanData.cash_flow_items) {
          if (cash_flow_item[merge_key] !== undefined) {
            let amount = String(merge_key).startsWith("expenese")
              ? -cash_flow_item[merge_key]
              : cash_flow_item[merge_key];
  
            amount = Math.round(amount);
            if ([0, -0].includes(amount)) {
              amount = "";
            }
  
            dataDebtItems.push(amount);
          }
        }
  
        dataDebt.push(dataDebtItems);
      }
  
      dataDebt = dataDebt.filter((item) => item.length !== 0);
  
      // หนี้ดอกลอย
      let debtShortList = balanceData?.debt_short_list?.find(
        (item) => item?.options_debt_short === "debt_shortterm_other"
      )?.short_term_others;
  
      if (debtShortList?.length > 0) {
        dataDebt = [
          ...dataDebt,
          ...findDebtShorttermOther(balanceData, futurePlanData).value,
        ];
      }
  
      // หนี้ีนอกระบบ
      let debtInformalShortterm = balanceData?.debt_short_list?.find(
        (item) => item?.options_debt_short === "debt_informal_shortterm"
      )?.informal_short_terms;
  
      if (debtInformalShortterm?.length > 0) {
        dataDebt = [
          ...dataDebt,
          ...findDebtInformalShortterm(balanceData, futurePlanData).value,
        ];
      }
  
      // เงินกู้ระยะสั้น
      let debtShorShortList = balanceData?.debt_short_list?.find(
        (item) => item?.options_debt_short === "debt_shortterm"
      )?.short_terms;
  
      if (debtShorShortList?.length > 0) {
        dataDebt = [
          ...dataDebt,
          ...findDebtShortterm(balanceData, futurePlanData).value,
        ];
      }
  
      // บัตรเครดิต
      let debtCreditcard = balanceData?.debt_short_list?.find(
        (item) => item?.options_debt_short === "debt_creditcard"
      )?.credit_cards?.map((item2, index2) => {
            let tempCalDebtCreditCard = calDebtCreditCard(item2);
      
            tempCalDebtCreditCard.creditor_name = item2?.creditor_name;
            tempCalDebtCreditCard.type_payment = item2?.type_payment;
            tempCalDebtCreditCard.pay_peryear = item2?.pay_peryear;
            tempCalDebtCreditCard.pay_permonth = item2?.pay_permonth;
            return tempCalDebtCreditCard;
          });
      
  
      if (debtCreditcard?.length > 0) {
  
  
        dataDebt = [
          ...dataDebt,
          ...findDebtCreditcard(balanceData, futurePlanData).value,
        ];
      }
  
  
      // หนี้ระยะยาว รถ
      let debtCar = balanceData?.debt_long_list?.find(
        (item) => item?.options_debt_long === "debt_car"
      )?.debt_long_cars;
  
      if (debtCar?.length > 0) {
        dataDebt = [
          ...dataDebt,
          ...findLongDebtCar(balanceData, futurePlanData).value,
        ];
      }
  
      // หนี้ระยะยาว บ้าน
      let DebtPlace = balanceData?.debt_long_list?.find(
        (item) => item?.options_debt_long === "debt_car"
      )?.debt_long_cars;
  
      if (DebtPlace?.length > 0) {
        dataDebt = [
          ...dataDebt,
          ...findLongDebtPlace(balanceData, futurePlanData).value,
        ];
      }
  
      // หนี้ระยะยาว อื่นๆ
      let DebtOther = balanceData?.debt_long_list?.find(
        (item) => item?.options_debt_long === "debt_long_other"
      )?.debt_long_others;
  
      if (DebtOther?.length > 0) {
        dataDebt = [
          ...dataDebt,
          ...findLongDebtOther(balanceData, futurePlanData).value,
        ];
      }
  
      return dataDebt;
    }, [futurePlanData]);


  const labels = useMemo(() => {
    let labels = [];
    for (const cash_flow_item of futurePlanData.cash_flow_items) {
      labels.push(cash_flow_item.age);
    }
    return labels;
  }, [futurePlanData]);

  const merge_keys_second = useMemo(() => {
    let merge_keys = [];

    // รายจ่ายบ้าน
    let expenseHome = futurePlanData?.expenese_home_items?.map(
      (item, index) => {
        let textCombine = item?.title + "_Is_type_expense" + "_home_expense";
        merge_keys = [...merge_keys, textCombine];
        return;
      }
    );

    // รายจ่ายรถ
    let expenseCar = futurePlanData?.expenese_car_items?.map((item, index) => {
      let textCombine = item?.title + "_Is_type_expense" + "_car_expense";
      merge_keys = [...merge_keys, textCombine];
      return;
    });

    // รายจ่ายลูก
    let expenseChild = futurePlanData?.expenese_children_items?.map(
      (item, index) => {
        let textCombine = item?.title + "_Is_type_expense" + "_child_expense";
        merge_keys = [...merge_keys, textCombine];
        return;
      }
    );

    // รายจ่ายการศึกษาลูก
    // console.log("educationData", educationData);
    if (futurePlanData?.expenese_children_education?.length > 0) {
      let expenseChildEducation = educationData?.map((item, index) => {
        let textCombine = item?.name + "_Is_type_expense" + "_child_Education";
        merge_keys = [...merge_keys, textCombine];
        return;
      });
    }

    // รายจ่ายท่องเที่ยว
    let expensetravel = futurePlanData?.expenese_travel_items?.map(
      (item, index) => {
        let textCombine = item?.title + "_Is_type_expense" + "_travel_expense";
        merge_keys = [...merge_keys, textCombine];
        return;
      }
    );

    // รายจ่ายสะสม
    let expensecollect = futurePlanData?.expenese_collection_items?.map(
      (item, index) => {
        let textCombine = item?.title + "_Is_type_expense" + "_collect_expense";
        merge_keys = [...merge_keys, textCombine];
        return;
      }
    );

    // รายจ่ายอื่นๆ
    let expenese_other_items = futurePlanData?.expenese_other_items?.map(
      (item, index) => {
        let textCombine = item?.title + "_Is_type_expense" + "_other_expense";
        merge_keys = [...merge_keys, textCombine];
        return;
      }
    );

    // รายรับมรดก
    let incomelegacy = futurePlanData?.income_legacy_items?.map(
      (item, index) => {
        let textCombine = item?.title + "_Is_type_income" + "_legacy_income";
        merge_keys = [...merge_keys, textCombine];
        return;
      }
    );

    // รายรับธุรกิจ
    let incomeBusiness = futurePlanData?.income_business_items?.map(
      (item, index) => {
        let textCombine = item?.title + "_Is_type_income" + "_business_income";
        merge_keys = [...merge_keys, textCombine];
        return;
      }
    );

    // รายรับอสังหาริมทรัพย์
    let incomeProperty = futurePlanData?.income_property_items?.map(
      (item, index) => {
        let textCombine = item?.title + "_Is_type_income" + "_property_income";
        merge_keys = [...merge_keys, textCombine];
        return;
      }
    );

    // รายรับอื่นๆ
    let incomeOther = futurePlanData?.income_other_items?.map((item, index) => {
      let textCombine = item?.title + "_Is_type_income" + "_Other_income";
      merge_keys = [...merge_keys, textCombine];
      return;
    });

    return merge_keys;
  }, [futurePlanData]);

  const moneyNeed = useMemo(() => {
    const findData = futurePlanData?.cash_flow_items?.filter((item) => {
      return item?.remain_accumulate < 0 && item?.remain < 0;
    });

    return findData;
  }, []);

  const isMobile = useIsMobile();
  const dynamicWidth = Math.max(labels.length * 80, 800);


  return (
    <div className=" flex flex-col justify-center items-center gap-2.5">
      <div className=" text-mainblue font-bold text-center ">
        กระแสเงินสดรายรับรายจ่ายของแผนอนาคต
      </div>
        <ChartCashFlow
        futurePlanData={futurePlanData}
        educationData={educationData}
        labels={labels}
        dataDebt={dataDebt}
        merge_keys={merge_keys}
        merge_keys_second={merge_keys_second}
        width={dynamicWidth}
      />
      {/* <ChartCashFlow
        part="report"
        isAverage={true}
        futurePlanData={futurePlanData}
        educationData={educationData}
        labels={labels}
        dataDebt={dataDebt}
        merge_keys={merge_keys}
        merge_keys_second={merge_keys_second}
        width={dynamicWidth}
        isHasDataLabel={true}
        outSideStyle="overflow-visible w-full h-fit"
        // width={750}
        // height={300}
        // heightOutside={"h-[300px] "}
        barOptions={{
          barPercentage: 1,
          barthickness: 30,
        }}
        options={{
          responsive: true,
          interaction: {
            intersect: true,
          },
          scales: {
            x: {
              stacked: true,
              title: {
                display: true,
                text: "อายุ(ปี)", // Label for X-axis
              },
              ticks: {
                autoSkip: true,
                font: {
                  size: 8,
                },
                callback: function (value, index, values) {
                  return (value + futurePlanData?.age_current) % 5 === 0
                    ? value + futurePlanData?.age_current
                    : "";
                },
              },
            },
            y: {
              stacked: true,
              title: {
                display: true,
                text: "จำนวนเงิน(บาท)", // Label for X-axis
              },
              ticks: {
                font: {
                  size: 8,
                },
                callback: function (value, index, values) {
                  return Math.abs(value) > 1000000
                    ? `${numeral(value / 1000000)?.format("0,0")}M`
                    : value > 10000
                    ? `${numeral(value / 10000)?.format("0,0")}k`
                    : value === 0
                    ? 0
                    : value < 1000
                    ? `${numeral(value)?.format("0,0")}`
                    : value;
                },
              },
            },
          },
          plugins: {
            legend: {
              display: false,
              labels: {
                boxWidth: 14,
                boxHeight: 14,
              },
              position: "bottom",
              align: "start",
            },
          },
        }}
      /> */}
      <div className=" bg-gray50 w-full rounded-lg h-full p-3 space-y-[6px]">
        {/* <div className=" text-maingray text-sm ">
        อายุ {age} ปี ต้องหารายรับเพิ่มอีก {numeral(value)?.format?.("0,0")}{" "}
        บาท
      </div> */}
        <ImageMain
          src="../images/cashflow.png"
          className=" w-12 h-12 mx-auto"
        />
        {/* <div className=" text-center text-mainblue text-sm ">
          เพื่อทำให้แผนอนาคตของคุณเป็นไปตามเป้าหมาย
          <div>
            คุณต้องหารายรับเพิ่มอีก
            <span className=" font-semibold">
              {" "}
              {numeral(futurePlanData?.sum_diff_total)?.format("0,0")} บาท
            </span>{" "}
          </div>
        </div> */}
        <div className=" flex flex-col text-center text-mainblue text-sm ">
          เพื่อทำให้แผนอนาคตของคุณเป็นไปตามเป้าหมาย
          {moneyNeed?.length > 0 &&
            moneyNeed?.map((item, index) => {
              return (
                <div key={index}>
                  อายุ {item?.age} คุณต้องหารายรับเพิ่มอีก
                  <span className=" font-semibold">
                    {" "}
                    {numeral(Math.abs(item?.remain))?.format("0,0")} บาท
                  </span>{" "}
                </div>
              );
            })}
        </div>
        <div className="flex justify-center text-center text-mainblue text-sm">
          รวม
          <span className=" pl-[5px] font-semibold">
            {" "}
            {numeral(
              Math.abs(
                moneyNeed?.reduce((acc, cur) => {
                  return acc + cur?.remain;
                }, 0)
              )
            )?.format("0,0")}{" "}
            บาท
          </span>{" "}
        </div>
      </div>
    </div>
  );
};

const mock_table_expense = [
  {
    title: "รถยนต์",
    year: 5,
    value: 2000000,
    end_year: 15,
  },
  {
    title: "กระเป๋าแบรนด์เนม",
    year: 1,
    value: 200000,
    end_year: 1,
  },
];

const mock_table_income = [
  {
    title: "ปล่อยเช่าอสังหาริมทรัพย์",
    year: 1,
    value: 6000000,
    duration: 10,
    isIncome_peryear: true,
  },
  {
    title: "กระเป๋าแบรนด์เนม",
    year: 1,
    value: 200000,
    end_year: 1,
  },
];

const currentEdu = (currentEducation) =>
  options_education_rank?.find((item) => item?.value === currentEducation)
    ?.label;
const targetEdu = (targetEducation) =>
  options_education_rank?.find((item) => item?.value === targetEducation)
    ?.label;
const underEdu = (underEducatiion) =>
  options_under_education?.find((item) => item?.value === underEducatiion)
    ?.label;

const ExpenseSection = ({
  futureExpensesItems,
  futurePlanData,
  userData,
  taxData,
  educationData,
}) => {
  return (
    <div>
      <div className={` ${STYLE_TEXT_CYAN} text-xl text-center `}>
        รายจ่ายในอนาคต 
      </div>

      {FutureHomeExpensePDF(futurePlanData?.expenese_home_items)?.map(
        (datalist, index) => {
          return (
            <FuturePlanDetail
              isFirst={index === 0}
              isLast={
                FutureHomeExpensePDF(futurePlanData?.expenese_home_items)
                  ?.length ===
                index + 1
              }
              userData={userData}
              taxData={taxData}
              datalist={datalist}
            />
          );
        }
      )}

      {FutureCarExpensePDF(futurePlanData?.expenese_car_items)?.map(
        (item, index) => {
          return (
            <FuturePlanDetail
              isFirst={index === 0}
              isLast={
                FutureCarExpensePDF(futurePlanData?.expenese_car_items)
                  ?.length ===
                index + 1
              }
              userData={userData}
              taxData={taxData}
              datalist={item}
            />
          );
        }
      )}

      {FutureChildrenExpensePDF(futurePlanData?.expenese_children_items)?.map(
        (item, index) => {
          return (
            <FuturePlanDetail
              isFirst={index === 0}
              isLast={
                FutureChildrenExpensePDF(
                  futurePlanData?.expenese_children_items
                )?.length ===
                index + 1
              }
              userData={userData}
              taxData={taxData}
              datalist={item}
              ischileFuture={true}
            />
          );
        }
      )}

      {FutureTravelExpensePDF(futurePlanData?.expenese_travel_items)?.map(
        (item, index) => {
          return (
            <FuturePlanDetail
              isFirst={index === 0}
              isLast={
                FutureTravelExpensePDF(futurePlanData?.expenese_travel_items)
                  ?.length ===
                index + 1
              }
              userData={userData}
              taxData={taxData}
              datalist={item}
            />
          );
        }
      )}

      {FutureCollectionExpensePDF(
        futurePlanData?.expenese_collection_items
      )?.map((item, index) => {
        return (
          <FuturePlanDetail
            isFirst={index === 0}
            isLast={
              FutureCollectionExpensePDF(
                futurePlanData?.expenese_collection_items
              )?.length ===
              index + 1
            }
            userData={userData}
            taxData={taxData}
            datalist={item}
          />
        );
      })}

      {FutureETCExpensePDF(futurePlanData?.expenese_other_items)?.map(
        (item, index) => {
          return (
            <FuturePlanDetail
              page={37}
              isFirst={index === 0}
              isLast={
                FutureETCExpensePDF(futurePlanData?.expenese_other_items)
                  ?.length ===
                index + 1
              }
              userData={userData}
              taxData={taxData}
              datalist={item}
            />
          );
        }
      )}

      {futurePlanData?.expenese_children_education?.length > 0 &&
        ChildrenEducationExpensePDF(educationData)?.map((item, index) => {
          return (
            <FuturePlanDetail
              page={37}
              isChildrenEducation={true}
              userData={userData}
              taxData={taxData}
              datalist={item}
            />
          );
        })}
    </div>
  );
};

const IncomeSection = ({
  futureIncomeItems,
  futurePlanData,
  userData,
  taxData,
}) => {
  return (
    <div>
      <div className={` ${STYLE_TEXT_CYAN} text-xl text-center `}>
        รายรับในอนาคต
      </div>
      {LegacyIncomePDF(futurePlanData?.income_legacy_items)?.map(
        (item, index) => {
          return (
            <FuturePlanIncomeDetail
              isFirst={index === 0}
              isLast={
                LegacyIncomePDF(futurePlanData?.income_legacy_items)?.length ===
                index + 1
              }
              userData={userData}
              taxData={taxData}
              datalist={item}
            />
          );
        }
      )}

      {SellBusinessIncomePDF(futurePlanData?.income_business_items)?.map(
        (item, index) => {
          return (
            <FuturePlanIncomeDetail
              isFirst={index === 0}
              isLast={
                SellBusinessIncomePDF(futurePlanData?.income_business_items)
                  ?.length ===
                index + 1
              }
              userData={userData}
              taxData={taxData}
              datalist={item}
            />
          );
        }
      )}

      {PropertyIncomePDF(futurePlanData?.income_property_items)?.map(
    (item, index) => {
      return (
        <FuturePlanIncomeDetail
          isFirst={index === 0}
          isLast={
            PropertyIncomePDF(futurePlanData?.income_property_items)?.length ===
            index + 1
          }
          userData={userData}
          taxData={taxData}
          datalist={item}
        />
      );
    }
  )}

  {OtherIncomePDF(futurePlanData?.income_other_items)?.map((item, index) => {
    return (
      <FuturePlanIncomeDetail
        isFirst={index === 0}
        isLast={
          OtherIncomePDF(futurePlanData?.income_other_items)?.length ===
          index + 1
        }
        userData={userData}
        taxData={taxData}
        datalist={item}
      />
    );
  })}
    </div>
  );
};

const ReportFuturePlanPage = () => {
  const navigate = useNavigate();
  const futurePlanData = useFuturePlanStore((state) => state.futurePlanData);
  const userData = useUserStore((state) => state.userData);
  const taxData = useTaxStore((state) => state.taxData);
  const educationData = useEducationStore((state) => state.educationData);

  const futureExpensesItems = useMemo(() => {
    const newFutureItems = [];
    const mergeItems = [
      {
        key: "ท่องเที่ยว",
        label: "ท่องเที่ยว",
        icon: "car_tour.png",
        title: "-",
        year: "-",
        amount: "",
      },
      {
        key: "วางแผนมีลูก",
        label: "วางแผนมีลูก",
        icon: "baby.png",
        title: "",
        year: "",
        amount: "",
      },
      {
        key: "ซื้อของสะสม",
        label: "ซื้อของสะสม",
        icon: "buy.png",
        title: "",
        year: "",
        amount: "",
      },
      {
        key: "อื่น ๆ",
        label: "อื่น ๆ",
        icon: "smile_open.png",
        title: "",
        year: "",
        amount: "",
      },
    ];

    if (futurePlanData?.expenese_travel_items?.length > 0) {
      const findIndex = mergeItems.findIndex(
        (item) => item.key === "ท่องเที่ยว"
      );
      mergeItems[findIndex] = {
        ...mergeItems[findIndex],
        ...futurePlanData?.expenese_travel_items[0],
      };
    }
    if (futurePlanData?.expenese_children_items?.length > 0) {
      const findIndex = mergeItems.findIndex(
        (item) => item.key === "วางแผนมีลูก"
      );
      mergeItems[findIndex] = {
        ...mergeItems[findIndex],
        ...futurePlanData?.expenese_children_items[0],
      };
    }
    if (futurePlanData?.expenese_collection_items?.length > 0) {
      const findIndex = mergeItems.findIndex(
        (item) => item.key === "ซื้อของสะสม"
      );
      mergeItems[findIndex] = {
        ...mergeItems[findIndex],
        ...futurePlanData?.expenese_collection_items[0],
      };
    }
    if (futurePlanData?.expenese_other_items?.length > 0) {
      const findIndex = mergeItems.findIndex((item) => item.key === "อื่น ๆ");
      mergeItems[findIndex] = {
        ...mergeItems[findIndex],
        ...futurePlanData?.expenese_other_items[0],
      };
    }

    if (mergeItems.length > 0) {
      for (const mergeItem of mergeItems) {
        newFutureItems.push({
          label: mergeItem.label,
          icon: mergeItem.icon,
          ...mergeItem,
          options: [
            {
              label: `ชื่อรายการ${mergeItem.key}`,
              value: `${mergeItem.title}`,
            },
            {
              label: "คาดการณ์ไว้อีก",
              value: `${mergeItem.year} ปี`,
            },
          ],
        });
      }
    }
    return newFutureItems;
  }, [futurePlanData]);

  const futureIncomeItems = useMemo(() => {
    const newFutureItems = [];
    const mergeItems = [
      {
        key: "รับมรดก",
        label: "รับมรดก",
        icon: "two_hearts.png",
        title: "-",
        year: "-",
        amount: "",
      },
      {
        key: "ขายธุรกิจ",
        label: "ขายธุรกิจ",
        icon: "saving_expenses.png",
        title: "",
        year: "",
        amount: "",
      },
      {
        key: "ปล่อยเช่าอสังหาริมทรัพย์",
        label: "ปล่อยเช่าอสังหาริมทรัพย์",
        icon: "invest_insuarance_all.png",
        title: "",
        year: "",
        amount: "",
      },
      {
        key: "อื่น ๆ",
        label: "อื่น ๆ",
        icon: "taxicon3.png",
        title: "",
        year: "",
        amount: "",
      },
    ];

    if (futurePlanData?.income_legacy_items?.length > 0) {
      const findIndex = mergeItems.findIndex((item) => item.key === "รับมรดก");
      mergeItems[findIndex] = {
        ...mergeItems[findIndex],
        ...futurePlanData?.income_legacy_items[0],
      };
    }
    if (futurePlanData?.income_business_items?.length > 0) {
      const findIndex = mergeItems.findIndex(
        (item) => item.key === "ขายธุรกิจ"
      );
      mergeItems[findIndex] = {
        ...mergeItems[findIndex],
        ...futurePlanData?.income_business_items[0],
      };
    }
    if (futurePlanData?.income_property_items?.length > 0) {
      const findIndex = mergeItems.findIndex(
        (item) => item.key === "ปล่อยเช่าอสังหาริมทรัพย์"
      );
      mergeItems[findIndex] = {
        ...mergeItems[findIndex],
        ...futurePlanData?.income_property_items[0],
      };
    }
    if (futurePlanData?.income_other_items?.length > 0) {
      const findIndex = mergeItems.findIndex((item) => item.key === "อื่น ๆ");
      mergeItems[findIndex] = {
        ...mergeItems[findIndex],
        ...futurePlanData?.income_other_items[0],
      };
    }

    if (mergeItems.length > 0) {
      for (const mergeItem of mergeItems) {
        newFutureItems.push({
          label: mergeItem.label,
          icon: mergeItem.icon,
          ...mergeItem,
          options: [
            {
              label: `ชื่อรายการ${mergeItem.key}`,
              value: `${mergeItem.title}`,
            },
            {
              label: "คาดการณ์ไว้อีก",
              value: `${mergeItem.year} ปี`,
            },
          ],
        });
      }
    }
    return newFutureItems;
  }, [futurePlanData]);

  useEffect(() => {
    let ignore = false;
    first_reload(ignore);
    return () => {
      ignore = true;
    };
  }, []);

  return (
    <Container>
      <div>
        <HeaderTitle
          title="รายงาน"
          isGoback
          onClickGoBack={() => {
            navigate("/report");
          }}
        />

        <div className={`${STYLE_REPORT_CONTAIN} flex flex-col gap-5`}>
          <HeaderReport
            icon={"/images/banknote-report.png"}
            title={"แผนอนาคต"}
            className={" z-20"}
          />
          <FlowSection futurePlanData={futurePlanData} />
          <ExpenseSection
            futureExpensesItems={futureExpensesItems}
            futurePlanData={futurePlanData}
            userData={userData}
            taxData={taxData}
            educationData={educationData}
          />
          <IncomeSection
            futureIncomeItems={futureIncomeItems}
            futurePlanData={futurePlanData}
            userData={userData}
          />
          <div className=" flex justify-center ">
            <MTButton
              onClick={() => {
                navigate("/report");
              }}
              text="ย้อนกลับ"
              color="bg-white"
              border="border border-maincyan"
              colortext="text-maincyan group-hover:text-white"
              hovercolor="hover:bg-maincyan group "
            />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ReportFuturePlanPage;
